import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { Calendar, Clock, User, Phone, ArrowLeft } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
export function BlogPostPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const navigate = useNavigate();
  const post = blogPosts.find(p => p.slug === slug);
  useEffect(() => {
    if (!post) {
      // Could redirect to 404 or back to blog
      // For now, we'll just let it render the "not found" state
    }
  }, [post, navigate]);
  if (!post) {
    return <div className="w-full min-h-screen bg-gray-50 flex flex-col" data-id="element-587">
        <div className="flex-grow flex items-center justify-center" data-id="element-588">
          <div className="text-center" data-id="element-589">
            <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-590">
              Post Not Found
            </h1>
            <Link to="/blog" className="text-blue-600 hover:text-blue-700 font-semibold flex items-center justify-center gap-2" data-id="element-591">
              <ArrowLeft size={20} data-id="element-592" /> Back to Blog
            </Link>
          </div>
        </div>
        <Footer data-id="element-593" />
      </div>;
  }
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-594">
      <Helmet data-id="element-595">
        <title data-id="element-596">{post.title} | I75 Audio & Video Blog</title>
        <meta name="description" content={post.metaDescription} data-id="element-597" />
      </Helmet>

      {/* Blog Header */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 mt-16" data-id="element-598">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-599">
          <Link to="/blog" className="inline-flex items-center text-blue-200 hover:text-white mb-6 transition-colors" data-id="element-600">
            <ArrowLeft size={16} className="mr-2" data-id="element-601" /> Back to Blog
          </Link>
          <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-602">
            {post.title}
          </h1>
          <div className="flex flex-wrap gap-6 text-blue-100" data-id="element-603">
            <div className="flex items-center gap-2" data-id="element-604">
              <Calendar size={18} data-id="element-605" />
              <span data-id="element-606">{post.date}</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-607">
              <Clock size={18} data-id="element-608" />
              <span data-id="element-609">{post.readTime}</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-610">
              <User size={18} data-id="element-611" />
              <span data-id="element-612">{post.author}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Content */}
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-613">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-614">
          <div className="prose prose-lg max-w-none prose-blue" data-id="element-615">
            {post.content}
          </div>

          {/* Call to Action */}
          <div className="mt-12 p-6 bg-blue-50 rounded-lg border-l-4 border-blue-600" data-id="element-616">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-617">
              Need Professional Installation?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-618">
              Let our experts handle your AV installation from start to finish.
              We serve all of Southwest Florida with professional, reliable
              service.
            </p>
            <a href="tel:2392038333" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-300" data-id="element-619">
              <Phone className="w-5 h-5 mr-2" data-id="element-620" />
              Call Now: (239) 203-8333
            </a>
          </div>
        </div>
      </article>

      <Footer data-id="element-621" />
    </div>;
}